module.exports = __webpack_public_path__ + "static/media/jump_btn.313ae6b0.png";